/**
 * Audit Flow Process — Scroll-animated SVG path
 * Reveals path on scroll and animates step blocks into view
 */
(function () {
  'use strict';

  function initSection(sectionId) {
    const pathEl = document.getElementById('audit-flow-path-' + sectionId);
    const flowWrapper = document.getElementById('audit-flow-wrapper-' + sectionId);

    if (!pathEl || !flowWrapper) return;

    const stepBlocks = flowWrapper.querySelectorAll('.audit-flow-process__step');
    const svgEls = flowWrapper.querySelectorAll('.audit-flow-process__svg');
    const mobileMediaQuery = window.matchMedia('(max-width: 749px)');

    // Path length
    const pathLength = pathEl.getTotalLength();
    pathEl.style.setProperty('--path-length', pathLength);
    pathEl.style.strokeDasharray = pathLength + ', ' + pathLength;
    pathEl.style.strokeDashoffset = pathLength;

    function syncResponsiveFlowHeight() {
      flowWrapper.style.removeProperty('height');

      svgEls.forEach(function (svgEl) {
        svgEl.setAttribute(
          'preserveAspectRatio',
          mobileMediaQuery.matches ? 'none' : 'xMidYMin meet'
        );
      });
    }

    // Intersection Observer for step blocks
    const contentObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const step = parseInt(entry.target.dataset.step, 10) || 1;
            const delay = step * 100;
            setTimeout(function () {
              entry.target.classList.add('visible');
            }, delay);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    stepBlocks.forEach(function (block) {
      contentObserver.observe(block);
    });

    // Scroll-linked path animation
    let ticking = false;

    function updatePath() {
      const wrapperRect = flowWrapper.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const wrapperHeight = wrapperRect.height;

      const startThreshold = windowHeight * 0.7;
      const rawProgress =
        (startThreshold - wrapperRect.top) /
        (wrapperHeight + startThreshold - windowHeight * 0.15);
      const progress = Math.max(0, Math.min(1, rawProgress));

      const offset = pathLength * (1 - progress);
      pathEl.style.strokeDashoffset = offset;

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(updatePath);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    window.addEventListener('resize', function () {
      syncResponsiveFlowHeight();
      const newLength = pathEl.getTotalLength();
      pathEl.style.setProperty('--path-length', newLength);
      pathEl.style.strokeDasharray = newLength + ', ' + newLength;
      requestAnimationFrame(updatePath);
    });

    syncResponsiveFlowHeight();
    requestAnimationFrame(updatePath);

    window.addEventListener('load', function () {
      syncResponsiveFlowHeight();
      requestAnimationFrame(updatePath);
    });
  }

  window.initAuditFlowProcess = initSection;

  function initAll() {
    const wrappers = document.querySelectorAll('[data-audit-flow-section]');
    wrappers.forEach(function (el) {
      const id = el.getAttribute('data-audit-flow-section');
      if (id) initSection(id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
